module.exports = __webpack_public_path__ + "img/hadiah-1.5jt.aecd0f25.png";